var styles = {"body-text":"RewardsSliderInfoModal_body-text_1s430_1","range-wrapper":"RewardsSliderInfoModal_range-wrapper_1s430_15"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
